export default __webpack_public_path__ + "static/IncidentReport-bc9d72c81fe7630f4b7882a6b1f2b3ed.png";